import styled, { css } from "styled-components";

const getColor = (color) => {
    switch (color) {
        case 'success':
            return 'var(--color-success)';
        case 'error':
            return 'var(--color-error)';
        case 'warning':
            return 'var(--color-warning)';
        case 'info':
            return 'var(--color-info)';
        default:
            return 'var(--theme-color-primary)';
    }
};

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--theme-color-primary);
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: all ease-in-out 0.3s;

    ${(props) =>
        props?.$fullwidth
            ? css`width: 100%;`
            : css`width: max-content;`
    }

    ${(props) =>
        props.$uppercase
            ? css`text-transform: uppercase;`
            : css`text-transform: capitalize;`
    }

    ${(props) =>
        props.size === 'small' &&
        css`
            padding: 8px 16px;
            font-size: 12px;
        `}

    ${(props) =>
        props.size === 'medium' &&
        css`
            padding: 10px 20px;
            font-size: 14px;
        `}

    ${(props) =>
        props.size === 'large' &&
        css`
            padding: 10px 24px;
            font-size: 16px;
        `}

    ${(props) =>
        props.$outline
            ? css`
                  background-color: transparent;
                  color: ${getColor(props.color)};
              `
            : css`
                  background-color: ${getColor(props.color)};
                  color: var(--theme-color-white);
                  opacity: 0.9;

                  &:hover:not(:disabled) {
                      opacity: 1;
                  }
              `}

    ${(props) =>
        props.$outline &&
        css`
            &:hover:not(:disabled) {
                background-color: ${getColor(props.color)};
                color: var(--theme-color-white);
            }
        `}

    &:disabled {
        filter: grayscale(1);
        opacity: 0.6;
        cursor: not-allowed;
    }

    svg {
        width: auto;
        height: 18px;
        margin-right: 4px;
    }

    ${(props) =>
        props.color &&
        css`
            border-color: ${getColor(props.color)};
        `}

    ${({ $rounded }) => {
        if ($rounded === true ) {
            return css`border-radius: 25px;`;
        }
        if ($rounded === false || $rounded === undefined || $rounded === null) {
            return '';
        }
        const value = typeof $rounded === 'number' ? `${$rounded}px` : $rounded;
        return css`border-radius: ${value};`;
    }}
`;